import { uiText, useUiLanguage } from '@/i18n/interface';
import React from 'react';
import { Label } from "@/components/ui/label";

interface Student {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  belt_level_id?: string;
  dojos?: { name: string };
}

interface BeltLevel {
  id: string;
  name: string;
  color: string;
  order_sequence: number;
}

interface StudentSelectorProps {
  students: Student[];
  beltLevels: BeltLevel[];
  selectedStudent: string;
  onStudentChange: (studentId: string, loadStudentData: (id: string) => void) => void;
  loadStudentData: (studentId: string) => void;
}

const StudentSelector: React.FC<StudentSelectorProps> = ({
  students,
  beltLevels,
  selectedStudent,
  onStudentChange,
  loadStudentData
}) => {
  useUiLanguage();
  const getStudentBelt = (beltLevelId?: string) => {
    return beltLevels.find(belt => belt.id === beltLevelId);
  };

  return (
    <div>
      <Label htmlFor="studentSelect">{uiText("Select Student")}</Label>
      <select
        id="studentSelect"
        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background"
        value={selectedStudent}
        onChange={(e) => onStudentChange(e.target.value, loadStudentData)}
      >
        <option value="">{uiText("Choose a student...")}</option>
        {students.map((student) => {
          const studentBelt = getStudentBelt(student.belt_level_id);
          const dojoName = student.dojos?.name;
          return (
            <option key={student.id} value={student.id}>
              {student.first_name} {student.last_name} ({student.email})
              {studentBelt && uiText(" - {{value0}}", { value0: studentBelt.name })}
              {dojoName && uiText(" [{{value0}}]", { value0: dojoName })}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default StudentSelector;